import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent, MatAutocompleteTrigger, MatOption } from '@angular/material/autocomplete';
import { MatChip, MatChipGrid, MatChipInput, MatChipInputEvent } from '@angular/material/chips';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import { MatFormField } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { map, Observable, startWith } from 'rxjs';

@Component({
  selector: 'app-add-remove-policy-countries',
  templateUrl: './add-remove-policy-countries.component.html',
  styleUrls: ['./add-remove-policy-countries.component.scss'],
  standalone: true,
  imports: [
    MatFormField,
    CommonModule,
    MatChipGrid,
    MatChip,
    MatChipInput,
    MatOption,
    MatAutocompleteModule,
    MatIcon,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule
  ]
})
export class AddRemovePolicyCountriesComponent implements OnInit, AfterViewInit {

  @ViewChild('countryInput') countryInput!: ElementRef<HTMLInputElement>;
  @ViewChild(MatAutocompleteTrigger) autocompleteTrigger!: MatAutocompleteTrigger;

  separatorKeysCodes: number[] = [ENTER, COMMA];
  countryControl = new FormControl('');
  existingCountries: any;
  allCountries: any[] = [];
  countries: any[] = [];
  selectedCountries: any[] = [];
  filteredCountries!: Observable<any[]>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddRemovePolicyCountriesComponent>
  ) {
    this.filteredCountries = this.countryControl.valueChanges.pipe(
      startWith(null),
      map((country: string | null) => (country ? this._filter(country) : this.allCountries.slice())),
    );
  }

  ngOnInit() {
    this.allCountries = this.data.countries;
    this.existingCountries = this.data.existingCountries;
    this.countries = this.existingCountries.map((country: any) => country.display_text);
    this.allCountries = this.data.countries.filter((o: any) => !this.existingCountries.find((o2: any) => o.id === o2.id));
  }

  ngAfterViewInit() {
    this.autocompleteTrigger.panelClosingActions.subscribe((e) => {      
      if (!(e && e.source)) {
        this.countryControl.setValue('');
        this.autocompleteTrigger.closePanel();
      }
    });
  }

  selectCountries(event: MatAutocompleteSelectedEvent): void {
    this.existingCountries.push(event.option.value);
    this.countries.push(event.option.viewValue);
    this.countryInput.nativeElement.value = '';
    this.countryControl.setValue(null);
  }

  onSaveChanges() {
    this.dialogRef.close(this.existingCountries);
  }

  onCancel() {
    this.dialogRef.close([]);
  }

  resetCountries() {
    this.allCountries = this.data.countries;
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      this.countries.push(value);
    }
    event.chipInput!.clear();
    this.countryControl.setValue(null);
  }

  remove(country: string): void {
    const index = this.countries.indexOf(country);
    if (index >= 0) {
      this.countries.splice(index, 1);
      this.existingCountries.splice(index, 1);
      this.resetCountries();
    }
  }

  private _filter(value: any): string[] {
    if (value.id > 0) {
      const filterValue = value.display_text.toLowerCase();
      return this.allCountries.filter(country => country.display_text.toLowerCase().includes(filterValue));
    } else {
      const filterValue = value.toLowerCase();
      return this.allCountries.filter(country => country.display_text.toLowerCase().includes(filterValue));
    }
  }
}